"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormatBp = useFormatBp;
var _formatters = require("../formatters");
var _useCulture = require("./useCulture");
/**
 * Returns parameter `value` formatted as the BPs (Bonus/Business Points).
 * @see {@link formatBp} for more information.
 *
 * @param value Numeric value to format
 * @returns `value` formatted as the BPs
 * @example
  // basic usage
  useFormatBp(1234.567);
 */
function useFormatBp(value) {
  const {
    culture
  } = (0, _useCulture.useCulture)();
  return (0, _formatters.formatBp)(value, culture);
}
